import IMask from 'imask';
export const maxInputLength = 220;
export const maxTextareaLength = 55000;
export const MOMENT_MASK = 'DD /` MM /` YYYY`';
export const MOMENT_FORMAT = 'DD / MM / YYYY';
export const DATE_LENGTH = 14;
export const DATE_VALIDATION = {
  YYYY: {
    mask: IMask.MaskedRange,
    from: 1900,
    to: 2100,
    placeholderChar: 'j'
  },
  MM: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
    placeholderChar: 'm'
  },
  DD: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 31,
    placeholderChar: 'd'
  },
  HH: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 23,
    placeholderChar: '`'
  }
};
export const copyToClipboard = async (inputField, type, url, callback) => {
  const {
    value
  } = inputField.current;
  const copyText = url ? `${url}/${value}` : value;
  if (window.clipboardData && window.clipboardData.setData) {
    window.clipboardData.setData('Text', copyText);
    if (callback) callback();
    return;
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(copyText);
      if (callback) callback();
      return;
    } catch (err) {
      console.warn('navigator.clipboard.writeText failed, falling back', err);
    }
  }
  const ta = document.createElement('textarea');
  ta.value = copyText;
  ta.setAttribute('readonly', '');
  ta.style.position = 'absolute';
  ta.style.left = '-9999px';
  ta.style.top = '0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    if (callback) callback();
  } catch (err) {
    console.error('execCommand(copy) failed', err);
    if (callback) callback(true, copyText);
  } finally {
    document.body.removeChild(ta);
  }
};
export const detectIsIosDevice = () => {
  const isTouch = 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
  return /iPod|iPhone|iPad|MacIntel/.test(navigator.platform) && isTouch;
};
export const textInputTypes = new Set(['password', 'editable', 'delete', 'copy']);